import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import ErrorIcon from '../../icons/error.svg';

const cx = classNames.bind(styles);
const regEx = /[^a-z0-9]/gi;

const Input = ({
  value, disabled, onChange, label, name, id, type = 'text', icon, hasError, errorMsg, className
}) => {
  const [active, setActive] = useState(false);
  const ref = useRef(null);

  useEffect(() => setActive(!!value || value === 0), [value]);

  const focusInput = () => {
    if (!disabled) {
      ref.current.focus();
    }
  };

  const inputId = id || `input-${label.toLowerCase().replace(regEx, '')}`;

  return (
    <div className={cx(className, { inputContainer: true, errorContainer: hasError })} onClick={focusInput}>
      {icon
        && <div className={cx({ inputIcon: true, errorIcon: hasError })}>{icon}</div>}
      <div className={styles.inputContent}>
        <label
          className={cx({ label: true, labelActive: active, errorLabel: hasError })}
          id={`label-${label.toLowerCase().split(' ').join('_')}`}
          htmlFor={inputId}
        >
          {label}
        </label>
        <input
          ref={ref}
          onFocus={() => setActive(true)}
          onBlur={(e) => setActive(e.target.value && e.target.value.length)}
          className={styles.input}
          id={inputId}
          disabled={disabled}
          onChange={onChange}
          name={name}
          value={value}
          type={type}
        />
        {hasError && <ErrorIcon className={styles.errorIndicator} />}
      </div>
      {hasError
        && <span className={styles.errorMsg}>{errorMsg}</span>}
    </div>
  );
};

Input.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.oneOf(['text', 'number']),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  hasError: PropTypes.bool,
  errorMsg: PropTypes.string,
  className: PropTypes.string,
};

export default Input;
